import Layout from "./components/Layout/Layout";
import React, { useState } from "react";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Education from "./pages/Educations/Education";
import Projects from "./pages/Projects/Projects";
import Techstack from "./pages/Techstack/Techstack";
import WorkExp from "./pages/workExp/WorkExp";
import Feedback from "./pages/Feedback/Feedback";
import ScrollToTop from "react-scroll-to-top";
import { useTheme } from "./context/ThemeContext";
import Certificates from "./pages/Certifications/Certifications";
import MobileNav from "./components/MobileNav/MobileNav";
import FeaturesCarousel from "./components/FeaturesCarousel/FeaturesCarousel";
import Blog from "./pages/Blog/Blog";
import BlogPreview from "./components/BlogPreview/BlogPreview";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/GlobalStyles.css";

function App() {
  const [theme] = useTheme();
  const [currentView, setCurrentView] = useState("portfolio");

  return (
    <>
      <div id={theme}>
        <ToastContainer />
        {currentView === "portfolio" ? (
          <>
            <MobileNav />
            <Layout />
            <div className="content-wrapper">
              <div className="container page-container">
                <Home />
                <About />
                <FeaturesCarousel />
                <Projects />
                <WorkExp />
                <BlogPreview onViewBlogDetail={() => setCurrentView("blogDetail")} />
                <Techstack />
                <Certificates />
                <Education />
                <Feedback />
                <Contact />
              </div>
            </div>
          </>
        ) : (
          <div className="blog-full-screen-container">
            <Blog onBack={() => setCurrentView("portfolio")} />
          </div>
        )}
      </div>
      <ScrollToTop
        smooth
        color="#ffffff"
        style={{
          backgroundColor: "#3b8ff3",
          borderRadius: "50%",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          width: "45px",
          height: "45px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transition: "all 0.3s ease"
        }}
      />
    </>
  );
}

export default App;
